module.exports = __webpack_public_path__ + "img/Candy Chen.016ecbdb.jpg";